import React, {useEffect, useRef} from "react";
import {default as MuiTooltip} from "@mui/material/Tooltip";

const Tooltip = props => {
    const {arrow = true, disable = false, titleCase = false, children, dangerousInnerHTML, ...other} = props;
    const tooltipRef = useRef(null);

    if (disable) {
        return children;
    }

    if (dangerousInnerHTML) {
        return (
            <MuiTooltip
                ref={tooltipRef}
                classes={{
                    tooltip: "ch-tooltip" + titleCase ? " ch-title-case-text" : ""
                }}
                arrow={arrow}
                enterDelay={300}
                enterNextDelay={150}
                leaveDelay={200}
                {...other}
            >
                <div dangerouslySetInnerHTML={{__html: dangerousInnerHTML}}></div>
            </MuiTooltip>
        )
    }

    return (
        <MuiTooltip
            ref={tooltipRef}
            classes={{
                tooltip: "ch-tooltip"
            }}
            arrow={arrow}
            enterDelay={300}
            enterNextDelay={150}
            leaveDelay={200}
            {...other}
        >
            {children}
        </MuiTooltip>
    )
}

export default Tooltip;